export const copyFindingInitialValues = () => ({
  date: "",
});
